<template>
  <hic-dialog :title="'文书模板' + (copyId ? '复制' : value.id ? '编辑' : '新建')" :visible="visible" @close="cancel" width="60rem" @open="open" :close-on-click-modal="false" append-to-body top="8vh">
    <el-form :inline="true" :model="value" :rules="comRules" ref="editor" label-width="4rem" label-position="right" style="padding-left: 3rem">
      <el-row v-if="value" :gutter="1">
        <el-col :span="8">
          <el-form-item label="领域" prop="scope">
            <hic-dict-selector v-model="value.scope" dict-type="MrScope" isEnum auto-first class="edit-input" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用户" prop="category">
            <hic-dict-selector v-model="value.category" dict-type="MrCategory" auto-first class="edit-input" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="类型" prop="type">
            <hic-dict-selector v-model="value.type" dict-type="MrType" auto-first class="edit-input" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="名称" prop="name">
            <el-input type="text" placeholder="请输入" v-model.trim="value.name" size="small" class="edit-input" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="编码" prop="code">
            <el-input type="text" placeholder="请输入" v-model.trim="value.code" :disabled="!!value.id" size="small" class="edit-input"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="科室" prop="deptCode">
            <!-- <el-cascader v-model="value.deptCode" :options="deptCascade" :props="{label:'text', emitPath: false}" size="small" class="edit-input"></el-cascader> -->
            <hic-dict-selector v-model="value.deptCode" dict-type="Dept" class="edit-input" title="选中项为空时，此模板对所有科室可见" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别">
            <el-radio v-model="value.gender" label="不限" size="mini">不限</el-radio>
            <el-radio v-model="value.gender" label="男" size="mini">男</el-radio>
            <el-radio v-model="value.gender" label="女" size="mini">女</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="重复">
            <el-checkbox type="text" v-model.trim="value.ifRepeatable" size="small">一份病历内允许多份</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="排序">
            <el-input-number v-model.trim="value.seqNo" size="small" class="edit-input"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-collapse>
        <el-collapse-item title="数据抽取：" name="1">
          <el-transfer v-model="selectedApis" :data="apis" :props="{ key: 'code', label: 'name' }" :titles="['待选结构', '已选结构']" filterable>
            <span slot-scope="{ option }">
              <small>{{ option.name }}</small>
              <el-popover placement="top-start" trigger="hover">
                <el-tree :data="[JSON.parse(option.struct)]" default-expand-all :props="utils.eleTreeProp">
                  <small slot-scope="{ node, data }">
                    <i :class="utils.eleIcon(data)" />
                    {{ node.label }}
                  </small>
                </el-tree>
                <i slot="reference" class="el-icon-search" />
              </el-popover>
            </span>
          </el-transfer>
        </el-collapse-item>
        <el-collapse-item title="数据输出：" name="2">
          <el-row :gutter="2">
            <el-col :span="7">
              <el-tree :data="docStructTree" default-expand-all highlight-current :expand-on-click-node="false" @node-click="nodeClick">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </el-col>
            <el-col :span="1">
              <br />
              <el-button type="primary" circle size="mini" plain icon="el-icon-d-arrow-right" @click="nodeClick()"></el-button>
              <br />
              <br />
              <el-button type="danger" circle size="mini" plain icon="el-icon-delete" @click="value.docFormat = null"></el-button>
            </el-col>
            <el-col :span="15">
              <el-input type="textarea" v-model="value.docFormat" :rows="fmtRows" class="f-h" @blur="docBlur"></el-input>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-switch v-if="!hideDisabled" class="pull-left" v-model="value.disabled" inactive-color="#67C23A" inactive-text="启用" active-color="#F56C6C" active-text="停用"></el-switch>
      <span v-if="value.disabled" class="pull-left left-pad danger">停用的模板无法作为文书添加到病历，之前已经生成的文书不受影响！</span>
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="disabledSave">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import editorUtils from "@/common/editorUtils";
  export default {
    props: {
      visible: Boolean,
      value: Object,
      hideDisabled: Boolean,
      apis: Array,
      copyId: Number,
    },
    data() {
      return {
        deptFilterKey: null,
        comRules: {
          scope: [
            {
              required: true,
              message: "请选择领域",
              trigger: "blur",
            },
          ],
          category: [
            {
              required: true,
              message: "请选择分类目录",
              trigger: "blur",
            },
          ],
          type: [
            {
              required: true,
              message: "请选择类型",
              trigger: "blur",
            },
          ],
          name: [
            {
              required: true,
              message: "请输入名称",
              trigger: "blur",
            },
            {
              max: 20,
              message: "名称长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
          code: [
            {
              required: true,
              message: "请输入编码",
              trigger: "blur",
            },
            {
              max: 20,
              message: "编码长度在 20 个字符以内",
              trigger: "blur",
            },
          ],
          deptCode: [
            {
              required: false,
              message: "请选择科室",
              trigger: "blur",
            },
          ],
        },
        disabledSave: false,
        selectedApis: [],
        utils: editorUtils,
        blurIndex: 0,
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "user", "deptCascade"]),
      depts() {
        let items = [];
        items.push(...this.dict.Dept.filter((d) => !this.deptFilterKey || d.text.indexOf(this.deptFilterKey) > -1 || d.code.indexOf(this.deptFilterKey) > -1 || (d.shortCode && d.short.indexOf(this.deptFilterKey) > -1)));
        items.sort((a, b) => {
          return `${a.codeChain}${a.code}` > `${b.codeChain}${b.code}`;
        });
        return items;
      },
      docStructTree() {
        if (!this.value.docStruct) {
          return [];
        }
        if (typeof this.value.docStruct == "object") {
          return this.genTree(this.value.docStruct);
        }

        return this.genTree(JSON.parse(this.value.docStruct));
      },
      fmtRows() {
        if (this.docStructTree.length < 5) {
          return 5;
        }
        return this.docStructTree.length;
      },
    },
    created() {
      this.open();
    },
    methods: {
      open() {
        if (this.value.apis) {
          this.selectedApis = JSON.parse(this.value.apis);
        }
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        let _this = this;
        this.value.apis = JSON.stringify(this.selectedApis);
        this.$refs.editor
          .validate()
          .then((valid) => {
            _this.disabledSave = true;
            let tmplEntity = this.$utils.Obj.clone(_this.value);
            if (typeof tmplEntity.docStruct == "object") {
              tmplEntity.docStruct = JSON.stringify(tmplEntity.docStruct);
            }
            if (this.copyId) {
              return this.$api.Tmpl.copy(this.copyId, tmplEntity);
            } else {
              return this.$api.Tmpl.save(tmplEntity);
            }
          })
          .then((newEntity) => {
            _this.$message.success("保存成功！");
            _this.$store.dispatch("loaders", "MrTemplate");
            _this.$emit("saved", newEntity);
            _this.$emit("update:visible", false);
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            _this.disabledSave = false;
          });
      },
      genTree(obj) {
        return Object.keys(obj).map((k) => {
          let ele = obj[k];
          let nod = {
            label: k,
          };
          // if (typeof ele != "object") {
          //   nod.label += `：${ele}`;
          // }
          if (Array.isArray(ele)) {
            nod.isArray = true;
            if (ele.length && typeof ele[0] === "object") {
              nod.children = this.genTree(ele[0]);
            }
          } else if (ele != null && typeof ele === "object") {
            nod.children = this.genTree(ele);
          }
          return nod;
        });
      },
      nodeClick(node, brk) {
        if (!brk || typeof brk == "object") {
          brk = "\r\n";
        }

        if (!this.value.docFormat) {
          this.value.docFormat = "";
        }
        if (!node) {
          Object.keys(this.docStructTree).forEach((k) => {
            this.nodeClick(this.docStructTree[k]);
          });
          return;
        }
        if (node.label == "allText" || node.label == "dbVer") {
          return;
        }
        if (node.children && node.children.length) {
          this.value.docFormat += node.label + "：" + brk + `[${node.label}:`;
          // this.value.docFormat = this.value.docFormat.slice(0, this.blurIndex) + node.label + "："  + "\r\n" + this.value.docFormat.slice(this.blurIndex)
          node.children.forEach((n) => {
            this.nodeClick(n, ";");
          });
          this.value.docFormat += "]\r\n";
        } else {
          this.value.docFormat += node.label + "：" + `{${node.label}}` + brk;
          // this.value.docFormat = this.value.docFormat.slice(0, this.blurIndex) + node.label + "：" + `{${node.label}}` + "\r\n" + this.value.docFormat.slice(this.blurIndex)
        }
      },
      docBlur(e) {
        this.blurIndex = e.srcElement.selectionStart;
      },
    },
  };
</script>
